import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - Calidad molienda
 **/
class CustomCalidadMolienda extends FormJaivana.form {
 
    constructor(props) {
        super(props);
        this.initForm                       = this.initForm.bind(this);
        this.successDatosFicha              = this.successDatosFicha.bind(this);
        this.succesTbDatosFicha             = this.succesTbDatosFicha.bind(this);
        this.gridOptionsTbDatosFichas       = Object.assign({}, this.gridOptions);
        this.setButtonValorActual           = this.setButtonValorActual.bind(this);
        this.valido                         = true;
        this.valorActualChange              = this.valorActualChange.bind(this);
        this.guardarValor                   = this.guardarValor.bind(this);
        this.succesGuardarValor             = this.succesGuardarValor.bind(this);
        this.uploadTbDatosFicha             = this.uploadTbDatosFicha.bind(this);
        this.continuarFicha                 = this.continuarFicha.bind(this);
        this.volverMoler                    = this.volverMoler.bind(this);

        this.setButtonObservacion           = this.setButtonObservacion.bind(this);
        this.observacionChange              = this.observacionChange.bind(this);
        this.guardarObservacion             = this.guardarObservacion.bind(this);
        this.successGrabarObservacion       = this.successGrabarObservacion.bind(this);
        this.traerDatosFicha                = this.traerDatosFicha.bind(this);
        this.traerItemsCalidadMolienda      = this.traerItemsCalidadMolienda.bind(this);
        this.verFormula                     = this.verFormula.bind(this);
        this.successVerFormula              = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula          = Object.assign({}, this.gridOptions);
        this.successClose                   = this.successClose.bind(this);
    }

    initForm() {        
        console.log('Calidad Molienda @version: 1.01.0054 @author: Juan David Nieto; @updateBy Sebastian Rios Echverri');
        this.traerDatosFicha();   
        this.getField('btnContinuar').setClick(this.continuarFicha);
        this.getField('btnVolveraMoler').setClick(this.volverMoler);
        //this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let body = {
            value: this.props.data.id_ficha,
        }
        this.generalFormat.nombre_accion = 'servicio_verformula_idfrm393'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successVerFormula,
                error:this.error_,
                general: this.generalFormat,
                showMessage: false
            }
        );
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    traerDatosFicha(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '393-servicio_traer_datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
    traerItemsCalidadMolienda(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTbDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
    /*this.generalFormat.nombre_accion = '393-Trae_tabla_calidad_molienda'; 
    this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'GET',
            body:bodys,
            success:this.succesTbDatosFicha,
            error:this.error_,
            general: this.generalFormat
        });*/
    }
    
    successDatosFicha(data){        
        this.traerItemsCalidadMolienda();
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('lista_items_produccion').setVisible(true);
            this.getField('lista_items_produccion').setItemsFichas(data.model);
        }else{
            this.getField('lista_items_produccion').setVisible(false);
        }
    }

    succesTbDatosFicha(data){
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0) 
        {
            
            this.gridOptionsTbDatosFichas['rowData']=[];
            this.getField('TbDatosficha').initData(this.gridOptionsTbDatosFichas);

            this.getField('TbDatosficha').toggle(true);
            this.gridOptionsTbDatosFichas['rowData'] = data.model;
            this.gridOptionsTbDatosFichas.paginationPageSize = 100;
            let configCellcol = new Map();
            configCellcol.set('valor_actual',{cellRenderer:this.setButtonValorActual,singleClickEdit: true,cellStyle: {backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' }, onCellValueChanged:this.valorActualChange, editable: true, field: 'Valor actual' });
            configCellcol.set('observaciones',{cellRenderer:this.setButtonObservacion,singleClickEdit: true,cellStyle: {backgroundColor: "rgb(238,238,238)",borderRadius:"5px",color:'rgb(0, 86, 201)' }, onCellValueChanged:this.observacionChange, editable: true,field: 'Observaciones' });

            this.getField('TbDatosficha').initData(this.gridOptionsTbDatosFichas, configCellcol);
        }else{ 
          this.getField('TbDatosficha').toggle(false);
          this.getField('fieldAlert').toggle(true,"No hay envasado","error");
        } 
    }

    setButtonValorActual(props){
        let valor_actual = props.data.valor_actual;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if(valor_actual !== null && valor_actual !== '' && valor_actual !== undefined){
            label.textContent = valor_actual;
            return "".formatoPrecio(props.data.valor_actual);
        }
        else{
            label.textContent = 0; 
        div.appendChild(label);
        return this.createElementJaivana(div);
        }
    }

    valorActualChange(props){
        let seguir = this.getField('TbDatosficha').cellValid(props.oldValue,props.newValue,'^[0-9]'); 
        if(seguir){
            if(props.oldValue !== props.newValue){
                let id = props.data.id;
                let valor_actual = props.newValue;
                if(valor_actual !== '' && parseFloat(valor_actual) >= 0){
                    /*if((valor_actual < props.data.valor_minimo) || (valor_actual > props.data.valor_maximo)){
                        props.data.valor_actual = 0;
                        this.getField('fieldAlert').toggle(true,"El valor ingresado no esta entre el rango especificado","error");
                        
                    }else{
                        */this.guardarValor(id,parseFloat(valor_actual));
                    
                }else{
                    props.data.valor_actual = 0;
                    this.getField('fieldAlert').toggle(true,"El campo no cumple con el formato deseado","error");
                }
            }
        }
    }
    

    guardarValor(id,valor_actual){
        let datos = {
            datos:{
                id: id, 
                valor_digitado: valor_actual,
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'valoractual', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.succesGuardarValor,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '393-Actualiza_valor_actual_de_la_tabla'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'PUT',
                body:body,
                success:this.succesGuardarValor,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    succesGuardarValor(response){
        if(response.estado_p === 200){
            this.uploadTbDatosFicha();
        }
    }

    //setbuttonObservacion
    setButtonObservacion(props){
        let observaciones = props.data.observaciones;
        let div = document.createElement("div");
        let label = document.createElement("label");
        label.textContent = observaciones;
        if((props.data.valor_actual > props.data.valor_maximo || props.data.valor_actual < props.data.valor_minimo) && (props.data.observaciones.length < 5)){
            //div.setAttribute('style','border: 1px solid rgb(255, 133, 133); height: 99%');
            this.valido = false;
        }
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    observacionChange(props){
        if(props.oldValue !== props.newValue && props.newValue !== ''){
            if(props.newValue.length > 5){
                let id = props.data.id;
                let observacion = props.newValue;
                this.guardarObservacion(id,observacion);
            }else{
                this.alertGeneral.toggle(true,'La observación debe contener mínimo 5 caracteres',"error");
                this.uploadTbDatosFicha();
            }
        }
    }

    guardarObservacion(idCell,observacion){
       this.getField('observaciones').setValue(observacion);
        let datos = {
            datos:{
                observaciones: this.getField('observaciones').getValue(), //
                id: idCell,
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'observacion', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarObservacion,
            error: this.error_,
            general: this.generalFormatPmv
        });

    /*this.generalFormat.nombre_accion = '393-Permite_actualizar_las_observaciones';
    this.service.send(
        {
            endpoint:this.constant.formConfiguration(),
            method:'PUT',
            body:body,
            success: this.successGrabarObservacion, 
            error:this.error_,
            general: this.generalFormat 
        }); */
    }

    successGrabarObservacion(data){
        if(data.estado_p === 200)
            this.uploadTbDatosFicha();
    }

    uploadTbDatosFicha(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.succesTbDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    continuarFicha(){        
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('btnContinuar').setDisabled(true);
        let datos = {
            datos:{
                id_formulario: this.formId,
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                puntos: this.props.data.puntos
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'continuar', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '393-Permite_pasar_a_la_actividad_de_calidad'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
    }

    successClose(data){
        this.getField('btnContinuar').setDisabled(false);
        this.getField('btnVolveraMoler').setDisabled(false);
        if(data.estado_p === 200){
            this.successCloseEstage(data);
        }
    }

    volverMoler(){
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('btnVolveraMoler').setDisabled(true);

        let datos = {
            datos:{
                id_formulario: this.formId,
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                puntos: this.props.data.puntos
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-calidadmolienda', operacion: 'volveramoler', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successClose,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '393-Permite_devolver_la_ficha_a_molienda'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
}

export default CustomCalidadMolienda;
FormJaivana.addController("prod-calidadmolienda",CustomCalidadMolienda);
